import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 5H8V1M1 8h4v4" stroke="#A7A7A7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);